var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 2V8",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 5H22",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2891 23.4375H20.3125V1.17188C20.3125 0.524658 19.7878 0 19.1406 0H2.73438C2.08716 0 1.5625 0.524658 1.5625 1.17188V23.4375H0.585938C0.262354 23.4375 0 23.6999 0 24.0234V25H21.875V24.0234C21.875 23.6999 21.6126 23.4375 21.2891 23.4375ZM6.25 3.71094C6.25 3.38735 6.51235 3.125 6.83594 3.125H8.78906C9.11265 3.125 9.375 3.38735 9.375 3.71094V5.66406C9.375 5.98765 9.11265 6.25 8.78906 6.25H6.83594C6.51235 6.25 6.25 5.98765 6.25 5.66406V3.71094ZM6.25 8.39844C6.25 8.07485 6.51235 7.8125 6.83594 7.8125H8.78906C9.11265 7.8125 9.375 8.07485 9.375 8.39844V10.3516C9.375 10.6751 9.11265 10.9375 8.78906 10.9375H6.83594C6.51235 10.9375 6.25 10.6751 6.25 10.3516V8.39844ZM8.78906 15.625H6.83594C6.51235 15.625 6.25 15.3626 6.25 15.0391V13.0859C6.25 12.7624 6.51235 12.5 6.83594 12.5H8.78906C9.11265 12.5 9.375 12.7624 9.375 13.0859V15.0391C9.375 15.3626 9.11265 15.625 8.78906 15.625ZM12.5 23.4375H9.375V19.3359C9.375 19.0124 9.63735 18.75 9.96094 18.75H11.9141C12.2376 18.75 12.5 19.0124 12.5 19.3359V23.4375ZM15.625 15.0391C15.625 15.3626 15.3626 15.625 15.0391 15.625H13.0859C12.7624 15.625 12.5 15.3626 12.5 15.0391V13.0859C12.5 12.7624 12.7624 12.5 13.0859 12.5H15.0391C15.3626 12.5 15.625 12.7624 15.625 13.0859V15.0391ZM15.625 10.3516C15.625 10.6751 15.3626 10.9375 15.0391 10.9375H13.0859C12.7624 10.9375 12.5 10.6751 12.5 10.3516V8.39844C12.5 8.07485 12.7624 7.8125 13.0859 7.8125H15.0391C15.3626 7.8125 15.625 8.07485 15.625 8.39844V10.3516ZM15.625 5.66406C15.625 5.98765 15.3626 6.25 15.0391 6.25H13.0859C12.7624 6.25 12.5 5.98765 12.5 5.66406V3.71094C12.5 3.38735 12.7624 3.125 13.0859 3.125H15.0391C15.3626 3.125 15.625 3.38735 15.625 3.71094V5.66406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerPlus);
export default __webpack_public_path__ + "static/media/customerPlus.55f22987cc904ed30ae9d6748d115128.svg";
export { ForwardRef as ReactComponent };